// extracted by mini-css-extract-plugin
export default {"fields":"KANdNL","mobile":"o7d1JQ"};